import { useQuery } from '@apollo/client';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allPages, updatePages } from '../../redux/pagesSlice';
import { selectedPage, selectPage } from '../../redux/selectedPageSlice';
import queries from '../../utils/query';

const PagesImport = ({ viewId }) => {
	const dispatch = useDispatch();
	const pages = useSelector(allPages);
	const { loading, error, data } = useQuery(queries.GET_VIEW(viewId));
	const selectedPageValue = useSelector(selectedPage);

	//page from queryString
	React.useEffect(() => {
		const page = window.location.hash;
		if (pages && page && page != selectedPageValue) {
			let newPage = page.replace('#', '');
			if (!newPage) {
				newPage = 'default-1';
			}
			dispatch(selectPage(newPage));
		}
	}, [window.location.hash, pages]);

	//No retorno do apollo, preenchendo o pages
	React.useEffect(() => {
		if (data && data.view && data.view.jsonContent) {
			if (data.view.jsonContent != '[]') {
				const contentString = data.view.jsonContent;
				try {
					// setPages(JSON.parse(contentString))
					const pages = JSON.parse(contentString);
					//fix, remover no futuro
					// setTemplates(pages, templateId);
					dispatch(updatePages(pages));
				} catch (e) {
					console.error(e); //Caso não seja uma string json
				}
			} else {
				// setTemplates(newDefaultPages, templateId);
				// dispatch(updatePages(defaultPagesObject));
				// setPages(defaultPages)
			}
		}
	}, [data]);

	return null;
};

export default PagesImport;
